export { HowRagWorks } from './HowRagWorks.component';
